module.exports = __webpack_public_path__ + "img/3_0160.550de90.png";